module.exports = __webpack_public_path__ + "static/media/slovenia.af560a54.png";